import { createAsyncThunk } from "@reduxjs/toolkit";
import { URL_COUNTRIES } from "../../config/connString";
import useAxios from "../../utils/useAxios";

const getAllCountries = createAsyncThunk(
  "countries/get-all-countries",
  async (data) => {
    try {
      const api = useAxios();
      const config = {
        params: {
          search: data.search,
          pageSize: data.pageSize,
          pageNumber: data.pageNumber,
          sortField: data.sortField,
          sortDirection: data.sortDirection,
        },
      };
      const response = await api.get(URL_COUNTRIES, config);
      return response.data;
    } catch (error) {
      return Promise.reject(error.response);
    }
  }
);

export { getAllCountries };
